"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSTMXMock = exports.ConfigCoMock = exports.ConfigUsMock = exports.ConfigAsisMock = exports.ConfigMXMock = void 0;
const translations_1 = require("../../translations");
const mx_1 = require("../mx");
const es_1 = require("../es");
const us_1 = require("../us");
const co_1 = require("../co");
const stmx_1 = require("../stmx");
class ConfigMXMock extends mx_1.Config {
    constructor() {
        super(...arguments);
        this.id = 'accounts';
        this.geTranslationsConfig = () => {
            return {
                baseVersion: {
                    language: this.language.toLocaleLowerCase(),
                    version: '1.0.0',
                },
                platform: translations_1.TranslationsPlatform.ACCOUNTS,
                translationsServiceHost: this.getTranslationsServiceHost(),
            };
        };
        this.getTrackerConfig = () => {
            return {
                tealiumTracker: {
                    configData: {},
                },
            };
        };
        this.libraries = () => [];
    }
}
exports.ConfigMXMock = ConfigMXMock;
class ConfigAsisMock extends es_1.Config {
    constructor() {
        super(...arguments);
        this.id = 'accounts';
        this.geTranslationsConfig = () => {
            return {
                baseVersion: {
                    language: this.language.toLocaleLowerCase(),
                    version: '1.0.0',
                },
                platform: translations_1.TranslationsPlatform.ACCOUNTS,
                translationsServiceHost: this.getTranslationsServiceHost(),
            };
        };
        this.getTrackerConfig = () => {
            return {
                tealiumTracker: {
                    configData: {},
                },
            };
        };
        this.libraries = () => [];
    }
}
exports.ConfigAsisMock = ConfigAsisMock;
class ConfigUsMock extends us_1.Config {
    constructor() {
        super(...arguments);
        this.id = 'cards';
        this.geTranslationsConfig = () => {
            return {
                baseVersion: {
                    language: this.language.toLocaleLowerCase(),
                    version: '1.0.0',
                },
                platform: translations_1.TranslationsPlatform.CARDS,
                translationsServiceHost: this.getTranslationsServiceHost(),
            };
        };
        this.getTrackerConfig = () => {
            return {
                tealiumTracker: {
                    configData: {},
                },
            };
        };
        this.libraries = () => [];
    }
}
exports.ConfigUsMock = ConfigUsMock;
class ConfigCoMock extends co_1.Config {
    constructor() {
        super(...arguments);
        this.id = 'cards';
        this.geTranslationsConfig = () => {
            return {
                baseVersion: {
                    language: this.language.toLocaleLowerCase(),
                    version: '1.0.0',
                },
                platform: translations_1.TranslationsPlatform.CARDS,
                translationsServiceHost: this.getTranslationsServiceHost(),
            };
        };
        this.getTrackerConfig = () => {
            return {
                tealiumTracker: {
                    configData: {},
                },
            };
        };
        this.libraries = () => [];
    }
}
exports.ConfigCoMock = ConfigCoMock;
class ConfigSTMXMock extends stmx_1.Config {
    constructor() {
        super(...arguments);
        this.id = 'cards';
        this.geTranslationsConfig = () => {
            return {
                baseVersion: {
                    language: this.language.toLocaleLowerCase(),
                    version: '1.0.0',
                },
                platform: translations_1.TranslationsPlatform.CARDS,
                translationsServiceHost: this.getTranslationsServiceHost(),
            };
        };
        this.getTrackerConfig = () => {
            return {
                tealiumTracker: {
                    configData: {},
                },
            };
        };
        this.libraries = () => [];
    }
}
exports.ConfigSTMXMock = ConfigSTMXMock;
//# sourceMappingURL=config.js.map